"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileLocation = exports.UriLocation = exports.UriLocationRaw = exports.BlobLocation = exports.LocalPathLocation = exports.Region = exports.NoAssemblyRegion = exports.PropTypes = exports.ElementId = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _shortid = _interopRequireDefault(require("shortid"));

var _mobxStateTree = require("mobx-state-tree");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mobxReact = require("mobx-react");

var _excluded = ["baseUri"],
    _excluded2 = ["locationType"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ElementId = _mobxStateTree.types.optional(_mobxStateTree.types.identifier, _shortid.default.generate); // PropTypes that are useful when working with instances of these in react components


exports.ElementId = ElementId;
var PropTypes = {
  Region: _propTypes.default.shape({
    refName: _propTypes.default.string.isRequired,
    start: _propTypes.default.number.isRequired,
    end: _propTypes.default.number.isRequired
  }),
  ConfigSchema: _mobxReact.PropTypes.objectOrObservableObject,
  Feature: _propTypes.default.shape({
    get: _propTypes.default.func.isRequired,
    id: _propTypes.default.func.isRequired
  })
};
exports.PropTypes = PropTypes;

var NoAssemblyRegion = _mobxStateTree.types.model('NoAssemblyRegion', {
  refName: _mobxStateTree.types.string,
  start: _mobxStateTree.types.number,
  end: _mobxStateTree.types.number,
  reversed: _mobxStateTree.types.optional(_mobxStateTree.types.boolean, false)
}).actions(function (self) {
  return {
    setRefName: function setRefName(newRefName) {
      self.refName = newRefName;
    }
  };
});

exports.NoAssemblyRegion = NoAssemblyRegion;

var Region = _mobxStateTree.types.compose('Region', NoAssemblyRegion, _mobxStateTree.types.model({
  assemblyName: _mobxStateTree.types.string
}));

exports.Region = Region;

var LocalPathLocation = _mobxStateTree.types.model('LocalPathLocation', {
  locationType: _mobxStateTree.types.literal('LocalPathLocation'),
  localPath: _mobxStateTree.types.string
}); // like how blobId is used to get a blob map


exports.LocalPathLocation = LocalPathLocation;

var BlobLocation = _mobxStateTree.types.model('BlobLocation', {
  locationType: _mobxStateTree.types.literal('BlobLocation'),
  name: _mobxStateTree.types.string,
  blobId: _mobxStateTree.types.string
});

exports.BlobLocation = BlobLocation;

var UriLocationRaw = _mobxStateTree.types.model('UriLocation', {
  locationType: _mobxStateTree.types.literal('UriLocation'),
  uri: _mobxStateTree.types.string,
  baseUri: _mobxStateTree.types.maybe(_mobxStateTree.types.string),
  internetAccountId: _mobxStateTree.types.maybe(_mobxStateTree.types.string),
  // auths information (such as tokens) needed for using this resource.
  // if provided, these must be completely sufficient for using it
  internetAccountPreAuthorization: _mobxStateTree.types.maybe(_mobxStateTree.types.model('InternetAccountPreAuthorization', {
    internetAccountType: _mobxStateTree.types.string,
    authInfo: _mobxStateTree.types.frozen()
  }))
});

exports.UriLocationRaw = UriLocationRaw;

var UriLocation = _mobxStateTree.types.snapshotProcessor(UriLocationRaw, {
  postProcessor: function postProcessor(snap) {
    var baseUri = snap.baseUri,
        rest = (0, _objectWithoutProperties2.default)(snap, _excluded);

    if (!baseUri) {
      return rest;
    }

    return snap;
  }
});

exports.UriLocation = UriLocation;

var FileLocation = _mobxStateTree.types.snapshotProcessor(_mobxStateTree.types.union(LocalPathLocation, UriLocation, BlobLocation), {
  // @ts-ignore
  preProcessor: function preProcessor(snapshot) {
    if (!snapshot) {
      return undefined;
    } // @ts-ignore


    var locationType = snapshot.locationType,
        rest = (0, _objectWithoutProperties2.default)(snapshot, _excluded2);

    if (!locationType) {
      // @ts-ignore
      var uri = rest.uri,
          localPath = rest.localPath,
          blob = rest.blob;
      var _locationType = '';

      if (uri !== undefined) {
        _locationType = 'UriLocation';
      } else if (localPath !== undefined) {
        _locationType = 'LocalPathLocation';
      } else if (blob !== undefined) {
        _locationType = 'BlobLocation';
      }

      return _objectSpread(_objectSpread({}, rest), {}, {
        locationType: _locationType
      });
    }

    return snapshot;
  }
});

exports.FileLocation = FileLocation;